module.exports = __webpack_public_path__ + "static/media/sponcer_SORCEA.8059cb38.png";